export default __webpack_public_path__ + "static/media/Group2131-yono@2x.339b4481.png";